// extracted by mini-css-extract-plugin
export default {"root":"DownloadForm_root__oT21O"};